<div class="container">
    <div class="results-box w-depth" [ngClass]="{single:((todayPrices.length && tomorrowPrices.length) && !showToday), reschedule: !!reschedule}">
      <div class="regulations-text">
            {{'REQUEST.RESULTS.REGULATIONS' | translate}}
      </div>
      <div class="fee-text" *ngIf="pricesLoaded.length == 2">
        {{'REQUEST.RESULTS.FEETEXT' | translate}}
      </div>
      <div class="day-results-container" *ngIf="pricesLoaded.length == 2">
      <div *ngIf="!todayPrices.length && !tomorrowPrices.length && !reschedule">
        <div class="no-results-message">{{'REQUEST.RESULTS.NORESULTSMESSAGE' | translate}}</div>
        <div class="back-btn"><button class="w-link-btn" (click)="backClicked()">{{'TAKEMEBACK' | translate}}</button>  </div>
      </div>
        <div class="day-col" *ngIf="showToday && todayPrices.length">
          <div class="day-title">{{'REQUEST.RESULTS.TODAY' | translate}}</div>
          <div class="day-results-box">
            <div *ngIf="todayPrices.length">
              <div class="day-result" *ngFor="let price of todayPrices" (click)="submitPrice(price)">
                <div class="price">
                  {{price?.price?.perGallon | currency}}/gal
                </div>
                <div class="day-hours">
                <span *ngIf="price.deliveryHours.length == 3">
                  {{'TIME.ANYTIME' | translate}}
                </span>
                  <span *ngIf="price.deliveryHours.length < 3">
                  <span *ngIf="price.deliveryHours.indexOf('morning')!=-1">
                    {{'TIME.MORNING' | translate}}
                    <span *ngIf="price.deliveryHours.length == 2"> and </span>
                  </span>
                  <span *ngIf="price.deliveryHours.indexOf('afternoon')!=-1">
                    {{'TIME.AFTERNOON' | translate}}
                    <span
                      *ngIf="price.deliveryHours.length == 2 && price.deliveryHours.indexOf('morning') == -1"> and </span>
                  </span>
                  <span *ngIf="price.deliveryHours.indexOf('evening')!=-1">
                    {{'TIME.EVENING' | translate}}
                  </span>
                </span>
                </div>
              </div>
            </div>
           <!-- <div *ngIf="!todayPrices.length" class="no-results">{{'REQUEST.RESULTS.NORESULTS' | translate}}</div>-->
          </div>
        </div>
        <div class="day-col" [ngClass]="{single: !showToday}">
          <div class="day-title" *ngIf="showToday && tomorrowPrices.length">{{'REQUEST.RESULTS.TOMORROW' | translate}}</div>
          <div class="day-results-box">
            <div *ngIf="tomorrowPrices.length">
              <div class="day-result" *ngFor="let price of tomorrowPrices" (click)="submitPrice(price)">
                <div class="price">
                  {{price?.price?.perGallon | currency}}/gal
                </div>
                <div class="day-hours">
                  <span *ngIf="price.deliveryHours.length == 3">
                    {{'TIME.ANYTIME' | translate}}
                  </span>
                  <span *ngIf="price.deliveryHours.length < 3">
                    <span *ngIf="price.deliveryHours.indexOf('morning')!=-1">
                      {{'TIME.MORNING' | translate}}
                      <span *ngIf="price.deliveryHours.length == 2"> and </span>
                    </span>
                    <span *ngIf="price.deliveryHours.indexOf('afternoon')!=-1">
                      {{'TIME.AFTERNOON' | translate}}
                      <span
                        *ngIf="price.deliveryHours.length == 2 && price.deliveryHours.indexOf('morning') == -1"> and </span>
                    </span>
                    <span *ngIf="price.deliveryHours.indexOf('evening')!=-1">
                      {{'TIME.EVENING' | translate}}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <!--   <div *ngIf="!tomorrowPrices.length" class="no-results">{{'REQUEST.RESULTS.NORESULTS' | translate}}</div>-->
          </div>
        </div>
        <div class="day-col reschedule-col" *ngIf="reschedule">
          <div class="day-title">
            {{reschedule.deliveryDate | date: 'MMM dd'}} {{'REQUEST.RESULTS.RESCHEDULETEXT' | translate}}
          </div>
          <div class="day-results-box" (click)="acceptReschedule()">
            <div class="day-result">
              <div class="price">
                {{reschedule.totals.nonDiscountTotal / reschedule.totals.amount | currency :'USD': 'symbol': '1.2-2'}}/gal
              </div>
              <div class="day-hours">
                <span>{{'TIME.' + reschedule.deliveryHour.toUpperCase() | translate}}</span>
              </div>
            </div>
            <div class="expiration-time" *ngIf="reschedule.rescheduleExpire">
              {{'REQUEST.RESULTS.EXPIRETEXT' | translate}}&nbsp;
              <app-countdown-timer [end]="reschedule.rescheduleExpire" (zeroTrigger)="checkExpiration(reschedule)"></app-countdown-timer>
            </div>
          </div>
        </div>
        <div class="cancel-box" *ngIf="reschedule">
          <button class="w-btn grey-btn" (click)="cancelReschedule()">{{'REQUEST.RESULTS.CANCELBTN' |  translate}}</button>
        </div>
      </div>
      <div class="wait-text" *ngIf="pricesLoaded.length != 2">
        {{'REQUEST.RESULTS.WAITTEXT' | translate}}
      </div>
    </div>
  </div>
  